
import { useContext } from 'react';
import './style/home.css';
import { AppContext } from '../../../contextApi/ContextApi';
import HomeCarousel from './HomeCarousel';
import HomeBrands from './HomeBrands';
export default function Home({website, isDashboard, setDisplay}) {
  const {primary_color, accent_color, secondary_color, hasCategories} = useContext(AppContext);
  
  return (
    <div id='homeMainDiv' style={{width:"100%",backgroundColor:secondary_color}}>
        <h1 style={{margin:"50px auto 20px", fontSize:"45px", color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}} dir='rtl'>{website?.settings?.homeHeaders?.main}</h1>
        <h2 style={{margin:"0 auto 50px", textShadow:`2px 2px 4px ${primary_color}`}}>{website?.settings?.homeHeaders?.sub}</h2>
        <div id='advertismentMainDiv'>
          <HomeCarousel/>
        </div>
        {hasCategories ? <h2 dir='rtl' id='home_salesHeader' style={{color:accent_color ,textShadow:`2px 2px 4px ${primary_color}`, borderBottom:`0.5px solid ${accent_color}`}}>מה חדש אצלנו?</h2> : null}
        {hasCategories ? <div id='home_salesContainer'>
          <HomeBrands website={website} isDashboard={isDashboard} setDisplay={setDisplay}/>
        </div> : null}
    </div>
  )
}
